import React, { useState } from 'react';
import { Tab } from '@headlessui/react';

interface ContentCreatorDashboardProps {
  children: React.ReactNode;
}

export const ContentCreatorDashboard: React.FC<ContentCreatorDashboardProps> = ({ children }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const tabs = [
    { name: 'Create Question', current: selectedTab === 0 },
    { name: 'My Questions', current: selectedTab === 1 },
    { name: 'Earnings', current: selectedTab === 2 },
    { name: 'Profile', current: selectedTab === 3 },
  ];

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="border-b border-gray-200">
        <Tab.Group onChange={setSelectedTab}>
          <Tab.List className="flex space-x-8 px-6">
            {tabs.map((tab) => (
              <Tab
                key={tab.name}
                className={({ selected }) =>
                  `py-4 px-1 border-b-2 font-medium text-sm ${
                    selected
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`
                }
              >
                {tab.name}
              </Tab>
            ))}
          </Tab.List>
          <Tab.Panels>
            <Tab.Panel className="p-6">{children}</Tab.Panel>
            <Tab.Panel className="p-6">
              {/* My Questions content will be added here */}
              <div className="text-center text-gray-500">My Questions content coming soon...</div>
            </Tab.Panel>
            <Tab.Panel className="p-6">
              {/* Earnings content will be added here */}
              <div className="text-center text-gray-500">Earnings content coming soon...</div>
            </Tab.Panel>
            <Tab.Panel className="p-6">
              {/* Profile content will be added here */}
              <div className="text-center text-gray-500">Profile content coming soon...</div>
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
}; 